import { render, staticRenderFns } from "./ContactsListItem.vue?vue&type=template&id=062f9684&scoped=true&lang=pug&"
import script from "./ContactsListItem.vue?vue&type=script&lang=js&"
export * from "./ContactsListItem.vue?vue&type=script&lang=js&"
import style0 from "./ContactsListItem.vue?vue&type=style&index=0&id=062f9684&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "062f9684",
  null
  
)

export default component.exports